import {
  SHOW_TURNTABLE,
  SET_TURNTABLE_SIZE,
  SET_RESULT_SELECTED,
  SET_CHOICES,
  SET_MODE,
  SET_HISTORY,
  CHANGE_KEY_TEXT,
  SAVE_LOCAL_CHOICES_LIST,
  SET_TITLE_OBJ,
  SET_SAVED_LISTS,
  SET_MYSTERY_WHEEL_ON,
  SET_MYSTERY_RESULT_ON,
  UPDATE_MYSTERY_SETTINGS,
  SET_SCORES,
  SET_AUTO_ADD_COUNT,
  SET_CHOICE_HD_IMAGES,
} from './constants'
import { setStartRotate } from '../turntable/actions'
import { setCurrentFileKey, setDataStatus } from '../common/actions'
import { duplicateHDImage, deleteHDImage } from '../../utils/HDImageUtil'

export const showTurntable = turntable => ({
  type: SHOW_TURNTABLE,
  payload: {
    turntable,
  },
})

export const setTurntableSize = size => ({
  type: SET_TURNTABLE_SIZE,
  payload: {
    size,
  },
})

export const setResultSelected = (
  result,
  resultIndex = -1,
  resultPieColor = null,
) => ({
  type: SET_RESULT_SELECTED,
  payload: {
    result,
    resultIndex,
    resultPieColor,
  },
})

export const setHistory = history => ({
  type: SET_HISTORY,
  payload: {
    history,
  },
})

export const setChoices =
  (choices, resetAngle = true) =>
  (dispatch, getState) => {
    if (resetAngle) {
      const state = getState()
      const startAngle = state.settings.spinBehavior.randomStart
        ? 2 * Math.PI * Math.random()
        : 0
      dispatch(setStartRotate(startAngle))
    }

    dispatch({
      type: SET_CHOICES,
      payload: {
        choices,
      },
    })
    dispatch(setDataStatus('Modified', 'Inputs'))
  }

export const setMode = mode => ({
  type: SET_MODE,
  payload: {
    mode,
  },
})

export const changeKeyText = () => ({
  type: CHANGE_KEY_TEXT,
})

export const saveLocalChoicesList = data => {
  return {
    type: SAVE_LOCAL_CHOICES_LIST,
    payload: {
      data,
    },
  }
}

export const setLoadSaveDataRIG =
  (id, choices = null, title = null, keyText = false) =>
  (dispatch, getState) => {
    dispatch(setCurrentFileKey(id))
    // dispatch(setListName(name))
    if (choices) dispatch(setChoices(choices))
    if (title) dispatch(setTitleObj(title))
    dispatch(setDataStatus('Unchanged'))
    if (keyText) dispatch(changeKeyText())
  }

export const itemToggleChanged =
  (status, index) => async (dispatch, getState) => {
    const choices = getState().rig.choices
    let newChoices = choices.slice(0)
    newChoices[index].filtered = !status //inverse the value
    dispatch(setChoices(newChoices.slice(0)))
  }

export const itemCloseClicked = id => async (dispatch, getState) => {
  const choices = getState().rig.choices
  const choiceHDImages = getState().rig.choiceHDImages
  if (choiceHDImages.length > 0) {
    const updatedHDImages = deleteHDImage(choiceHDImages, id)
    dispatch(setChoiceHDImages(updatedHDImages))
  }

  let array = choices.slice(0)
  array.splice(id, 1)
  if (array.length === 0) {
    dispatch(setMode(0))
  }
  dispatch(setChoices(array.slice(0)))
  dispatch(changeKeyText())
}

export const itemDuplicateClicked = index => async (dispatch, getState) => {
  const choices = getState().rig.choices
  let array = choices.slice(0)
  const insertIndex = index + 1
  array.splice(insertIndex, 0, { ...choices[index], filtered: false })

  // Update HD images
  const choiceHDImages = getState().rig.choiceHDImages
  if (choiceHDImages.length > 0) {
    let updatedHDImages = [...choiceHDImages]
    updatedHDImages = duplicateHDImage(
      choiceHDImages,
      updatedHDImages,
      index,
      insertIndex,
    )
    dispatch(setChoiceHDImages(updatedHDImages))
  }
  dispatch(setChoices(array.slice(0)))
  dispatch(changeKeyText())
}

//03-07-2021 add title
export const setTitleActive = active => dispatch => {
  dispatch(setTitleObj({ active }))
}

export const setTitleText = text => dispatch => {
  dispatch(setTitleObj({ text }))
}

export const setTitleObj = obj => dispatch => {
  dispatch({
    type: SET_TITLE_OBJ,
    payload: {
      obj,
    },
  })
  dispatch(setDataStatus('Modified', 'Title & Desc.'))
}

export const setSavedLists = lists => {
  return {
    type: SET_SAVED_LISTS,
    payload: {
      lists,
    },
  }
}

export const setMysteryWheelOn = status => dispatch => {
  dispatch({
    type: SET_MYSTERY_WHEEL_ON,
    payload: {
      status,
    },
  })
  dispatch(setDataStatus('Modified', 'Mystery'))
}

export const setMysteryResultOn = status => dispatch => {
  dispatch({
    type: SET_MYSTERY_RESULT_ON,
    payload: {
      status,
    },
  })
  dispatch(setDataStatus('Modified', 'Mystery'))
}

export const updateMysterySettings =
  (mysteryWheelOn, mysteryResultOn) => async (dispatch, getState) => {
    try {
      const state = getState()
      const pastMysteryWheelOn = state.rig.mysteryWheelOn
      dispatch({
        type: UPDATE_MYSTERY_SETTINGS,
        payload: {
          mysteryWheelOn,
          mysteryResultOn,
        },
      })
      // redraw wheel
      if (pastMysteryWheelOn !== mysteryWheelOn) {
        dispatch(showTurntable(null))
      }
      dispatch(setDataStatus('Unchanged')) //load from sharewheel and load list
    } catch (error) {
      console.log(error)
    }
  }

export const setScores =
  (scores, dataStatus = 'Modified') =>
  dispatch => {
    dispatch({
      type: SET_SCORES,
      payload: {
        scores,
      },
    })
    dispatch(setDataStatus(dataStatus, 'Scores'))
  }

export const setAutoAddCount = status => ({
  type: SET_AUTO_ADD_COUNT,
  payload: {
    status,
  },
})

export const setChoiceHDImages = choiceHDImages => ({
  type: SET_CHOICE_HD_IMAGES,
  payload: {
    choiceHDImages,
  },
})
